import Button from "../Button";
const Final=({data})=>{

    return <div className="w-11/12 mt-10 rounded-lg flex flex-col justify-center items-center p-5 bg-white lg:w-6/12 mx-auto">
        {data?.icon}

        <h1 className={`text-lg mb-1 font-bold  ${data?.status==='success' && 'text-green-500'} ${data?.status==='error' && 'text-red-500' } ${data?.status==='warning' && 'text-yellow-500' }`}>{data?.title||''}</h1>
        <p className="text-sm text-center">{data?.message||''}</p>
        <Button onClick={data?.onClick ? data.onClick:()=>{}} theme={data?.status==='success' ? 'green':data?.status==='warning'?'warning':'red'} className="w-full rounded-lg text-sm mt-5 " >بازگشت به دیوار</Button>
    </div>
}
export default Final